import { ref, computed } from '@vue/composition-api';

function autoExpand({ embeddedCard }) {
  let levelToExpand = embeddedCard.nestedLevel;

  let didExpansion;
  let nothingLeftToExpand = true;

  do {
    nothingLeftToExpand = true;
    levelToExpand += 1;
    expandLevelN({ embeddedCard: embeddedCard, n: levelToExpand });
  } while (!didExpansion && !nothingLeftToExpand);

  function expandLevelN({ embeddedCard, n }) {
    if (embeddedCard) {
      //if the card is at the level n exit
      if (embeddedCard.nestedLevel == n) {
        if (embeddedCard.pageNoteLength != 0) {
          nothingLeftToExpand = false;
        } else return;
        return;
      }

      // if the card is not expanded, then expand it
      if (!embeddedCard.show && embeddedCard.pageNoteLength > 0) {
        embeddedCard.showOrHide({});
        didExpansion = true;
        return;
      }

      if (embeddedCard.pageNoteLength > 0) {
        //Make an array of the children embedded cards

        const childrenCards = Object.entries(embeddedCard.$refs.cardDoc.$refs)
          .filter(element => element[0] != 'dragSelect')
          .map(x => x[1].$refs.embeddedCard);

        //go through all children and call recurse on them
        childrenCards.forEach(childCard => {
          expandLevelN({ embeddedCard: childCard, n: n });
        });
      }
    }
  }
}

function autoContract({ embeddedCard }) {
  let maxLevel = embeddedCard.nestedLevel + 1;
  let cardsToClose = [];

  function traverseTree({ embeddedCard }) {
    if (embeddedCard) {
      //if I have children
      if (embeddedCard.show && embeddedCard.pageNoteLength > 0) {
        //is the card the deepest one found yet?  If so, make a new cardsToClose list
        if (embeddedCard.nestedLevel > maxLevel) {
          cardsToClose = [embeddedCard];
          maxLevel = embeddedCard.nestedLevel;

          //otherwise, is the card the same level as the deepest ones found?  If so, add them to cardsToClose
        } else if (embeddedCard.nestedLevel == maxLevel) {
          cardsToClose.push(embeddedCard);
        }
        const childrenCards = Object.entries(embeddedCard.$refs.cardDoc.$refs).map(
          x => x[1].$refs.embeddedCard
        );

        childrenCards.forEach(childCard => {
          traverseTree({
            embeddedCard: childCard
          });
        });
      }
    }
  }

  traverseTree({ embeddedCard });
  cardsToClose.forEach(childCard => {
    childCard.showOrHide({ showOnly: false });
  });
  if (!cardsToClose.length) {
    return 'empty';
  }
}

export default function useAutoExpand() {
  const logCTX = ({ component, nestLevel = 0 }) => {
    if (component == undefined) {
      // no children
    } else {
      let componentChildren = Object.entries(component.$refs).filter(
        element => element[0] != 'dragSelect'
      );
      componentChildren.forEach(element => {
        const newNest = nestLevel + 1;
        logCTX({ component: element[1].$refs.embeddedCard.$refs.cardDoc, nestLevel: newNest });
      });
    }
  };

  return {
    logCTX,
    autoExpand,
    autoContract
  };
}
